export default "__VITE_ASSET__cgGJw4Gi__"